import { defineComponent as q, useId as E, computed as k, useTemplateRef as M, createElementBlock as p, openBlock as c, normalizeClass as I, createElementVNode as u, createCommentVNode as x, mergeProps as N, unref as n, createVNode as v, toDisplayString as B, withModifiers as D } from "vue";
import { ScalarListboxCheckbox as P, ScalarMarkdown as j } from "@scalar/components";
import { emitCustomEvent as w } from "@scalar/workspace-store/events";
import z from "./ServerVariablesForm.vue.js";
import { useWorkspace as L } from "../../store/store.js";
const R = ["aria-expanded"], T = { class: "overflow-hidden text-ellipsis whitespace-nowrap" }, W = ["id"], $ = { key: 0 }, A = { class: "description text-c-3 px-3 py-1.5" }, Q = /* @__PURE__ */ q({
  __name: "ServerDropdownItem",
  props: {
    collection: {},
    operation: {},
    server: {},
    serverOption: {},
    type: {}
  },
  emits: ["update:variable"],
  setup(_, { emit: O }) {
    const e = _, U = O, f = E(), { collectionMutators: m, requestMutators: l, servers: b } = L(), C = (r, t) => {
      var i, s, a, h, g;
      if (S(r) && (t == null || t.stopPropagation()), o.value) {
        (s = (i = e.operation) == null ? void 0 : i.servers) != null && s.length && l.edit(e.operation.uid, "selectedServerUid", null), e.type === "collection" ? (m.edit(
          e.collection.uid,
          "selectedServerUid",
          void 0
        ), w(y.value, "scalar-update-selected-server", {
          value: void 0,
          options: { disableOldStoreUpdate: !0 }
        })) : e.type === "request" && e.operation && l.edit(e.operation.uid, "selectedServerUid", null);
        return;
      }
      e.type === "collection" && e.collection ? ((h = (a = e.operation) == null ? void 0 : a.servers) != null && h.length && l.edit(e.operation.uid, "selectedServerUid", null), m.edit(
        e.collection.uid,
        "selectedServerUid",
        r
      ), w(y.value, "scalar-update-selected-server", {
        value: (g = b[r]) == null ? void 0 : g.url,
        options: { disableOldStoreUpdate: !0 }
      })) : e.type === "request" && e.operation && l.edit(e.operation.uid, "selectedServerUid", r);
    }, o = k(() => {
      var r;
      return e.type === "collection" ? e.collection.selectedServerUid === e.serverOption.id && !((r = e.operation) != null && r.selectedServerUid) : e.type === "request" && e.operation ? e.operation.selectedServerUid === e.serverOption.id : !1;
    }), S = (r) => {
      if (!r)
        return !1;
      const t = b[r];
      return Object.keys((t == null ? void 0 : t.variables) ?? {}).length > 0;
    }, d = k(
      () => {
        var r;
        return o.value && S(((r = e.server) == null ? void 0 : r.uid) ?? "");
      }
    ), V = (r, t) => {
      U("update:variable", r, t);
    }, y = M("wrapper-ref");
    return (r, t) => {
      var i, s;
      return c(), p("div", {
        ref: "wrapper-ref",
        class: I(["group/item flex min-h-fit flex-col rounded border", { "border-transparent": !o.value }])
      }, [
        u("button", N(d.value ? { "aria-controls": n(f) } : {}, {
          "aria-expanded": d.value,
          class: ["flex min-h-8 cursor-pointer items-center gap-1.5 rounded px-1.5", o.value ? "text-c-1 bg-b-2" : "hover:bg-b-2"],
          type: "button",
          onClick: t[0] || (t[0] = (a) => C(r.serverOption.id, a))
        }), [
          v(n(P), { selected: o.value }, null, 8, ["selected"]),
          u("span", T, B(r.serverOption.label), 1)
        ], 16, R),
        d.value ? (c(), p("div", {
          key: 0,
          id: n(f),
          class: "bg-b-2 divide divide-y rounded-b border-t *:pl-4",
          onClick: t[1] || (t[1] = D(() => {
          }, ["stop"]))
        }, [
          v(z, {
            variables: (i = r.server) == null ? void 0 : i.variables,
            "onUpdate:variable": V
          }, null, 8, ["variables"]),
          (s = r.server) != null && s.description ? (c(), p("div", $, [
            u("div", A, [
              v(n(j), {
                value: r.server.description
              }, null, 8, ["value"])
            ])
          ])) : x("", !0)
        ], 8, W)) : x("", !0)
      ], 2);
    };
  }
});
export {
  Q as default
};
